module.exports = __webpack_public_path__ + "static/media/guessmynumber.8a8cbbe3.png";